import HiddenSeoWrapper from "@/components/HiddenSeoWrapper";
import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import { ColorIcon, colors, customEvent, HStack, VStack } from "goi_common";
import ParlorListTabPanel from "./ParlorListTabPanel";
import { useEffect, useMemo, useState } from "react";

import DiscountParlorCTA from "./DiscountParlorCTA";
import TotalPriceSection from "./TotalPriceSection";
import BannerCTA from "@/components/common/BannerCTA";

function TabInfoSection({
  expectedParlorPrice,
  parlors,
  serviceName,
  name,
  sidoName,
  sido,
  sigunguName,
  sigungu,
}: {
  expectedParlorPrice: number;
  parlors: Array<any>;
  serviceName?: string;
  name: string;
  sidoName: string;
  sido: string;
  sigunguName?: string;
  sigungu?: string;
}) {
  const [tabIndex, setTabIndex] = useState(-1);

  useEffect(() => {
    const index = [
      "장례서비스 추천받기",
      serviceName ? "저렴한 순으로 보기" : "장례식장 전체 목록",
    ].findIndex((name) => name === location.hash.slice(1));
    if (index >= 0) {
      setTabIndex(index);
    } else {
      setTabIndex(0);
    }
  }, []);

  const price = useMemo(() => {
    const expensive = Math.ceil(expectedParlorPrice) + 4_800_000 + 4_000_000;
    return {
      expensive,
      goi: Math.ceil(expectedParlorPrice) + 2_500_000 + 4_000_000,
    };
  }, [expectedParlorPrice]);

  if (tabIndex < 0) return <></>;

  return (
    <>
      <Tabs
        isFitted
        defaultIndex={tabIndex}
        index={tabIndex}
        onChange={(index) => setTabIndex(index)}
        style={{ color: `${colors.gray500}`, borderColor: `${colors.gray300}` }}
      >
        <TabList>
          <Tab
            style={{
              fontSize: "14px",
            }}
            onClick={() => {
              customEvent({
                newGtm: {
                  path: "parlor_region",
                  trigger_and_target: "tab_recomm-tab",
                },
              });
            }}
            _selected={{
              color: `${colors.black}`,
              borderColor: `${colors.black}`,
              fontWeight: 700,
            }}
          >
            장례서비스 추천받기
          </Tab>
          <Tab
            style={{
              fontSize: "14px",
            }}
            onClick={() => {
              customEvent({
                newGtm: {
                  path: "parlor_region",
                  trigger_and_target: "tab_parlor_list-tab",
                },
              });
            }}
            _selected={{
              color: `${colors.black}`,
              borderColor: `${colors.black}`,
              fontWeight: 700,
            }}
          >
            {serviceName ? "저렴한 순으로 보기" : "장례식장 전체 목록"}
          </Tab>
        </TabList>
        <div style={{ marginTop: "16px" }} />
        <TabPanels>
          <TabPanel padding="0">
            <DiscountParlorCTA
              sido={sido}
              sidoName={sidoName}
              sigungu={sigungu}
              name={name}
              parlors={parlors}
            />
            <TotalPriceSection
              name={name}
              price={price.expensive.toLocaleString()}
              goiCompareSection={
                <Box
                  style={{
                    border: `1px solid ${colors.green100}`,
                    borderRadius: "5px",
                    width: "100%",
                    marginTop: "16px",
                  }}
                >
                  <HStack margin="0 0 1px" background={colors.green50} padding="4px 12px" gap="4px">
                    <ColorIcon
                      name={"arrow_fat_down_fill"}
                      color={colors.success}
                      width="20px"
                      height="20px"
                    />
                    <span className={`caption_12_sb green450`}>
                      고이에서는 같은 서비스를{" "}
                      {((1 - price.goi / price.expensive) * 100).toFixed(0)}% 이상 저렴한 합리적인
                      가격에 이용할 수 있어요.
                    </span>
                  </HStack>
                </Box>
              }
            />
          </TabPanel>
          <TabPanel padding="0">
            <BannerCTA
              variant="GREEN"
              title="500만원을 더 지불할 필요는 없습니다."
              subtitle="한번 뿐인 장례, 비용이 전부는 아니지만, "
              event={{ path: "parlor_region", trigger_and_target: "banner_CTA-uv_step_guide" }}
              href="/step-guide/initiation/"
            />
            <VStack background={colors.warmGray100}>
              <Box
                as="h2"
                padding="18px 24px 0"
                className="subtitle_18_b"
                aria-label={name + " 추천 리스트"}
              >
                {name} 추천 리스트
              </Box>
              <HiddenSeoWrapper>{name}의 장례식장 추천 리스트 입니다.</HiddenSeoWrapper>
              <ParlorListTabPanel
                name={name}
                parlors={parlors}
                serviceName={serviceName}
                sido={sido}
                sigungu={sigungu}
                expectedParlorPrice={parlors.length === 0 ? 3700000 : expectedParlorPrice}
              />
            </VStack>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </>
  );
}

export default TabInfoSection;
